const initProductCardVariants = (root = document) => {
  const productCardForms = root.querySelectorAll('[data-product-card] form[data-product-form]');
  if (!productCardForms.length) return;

  productCardForms.forEach((form) => {
    const variantSelectEl = form.querySelector('select[name="variant"]');
    const variantIdInput = form.querySelector('input[name="id"]');
    if (!variantSelectEl || !variantIdInput) return;

    const syncCardVariantId = () => {
      variantIdInput.value = variantSelectEl.value;
    };

    if (variantSelectEl.dataset.variantBound !== 'true') {
      variantSelectEl.addEventListener('change', syncCardVariantId);
      variantSelectEl.dataset.variantBound = 'true';
    }

    syncCardVariantId();
  });
};

export default initProductCardVariants;
